import { render, staticRenderFns } from "./calcVesselsDotsTotal.vue?vue&type=template&id=521addcc"
import script from "./calcVesselsDotsTotal.vue?vue&type=script&lang=js"
export * from "./calcVesselsDotsTotal.vue?vue&type=script&lang=js"
import style0 from "./calcVesselsDotsTotal.vue?vue&type=style&index=0&id=521addcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports